module.exports = __webpack_public_path__ + "static/img/thank.87e2bc76.png";